import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, FormControl, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import * as Yup from "yup";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import UserContext from "../../../UserContext";
import {config} from "../../../constant";

export default function DialogIdentification({open, onClose}) {
    const {user, setUser} = useContext(UserContext);
    const [users, setUsers] = useState(null);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        userId: Yup.number().transform(value => (Number.isNaN(value) ? undefined : value)).required("Utilisateur est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            userId: user ? user.id : null
        }
    });

    useEffect(() => {
        fetch(`${config.BASE_URL}/people`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
                return response.json();
            }).then(data => {
                setUsers(data);
            }).catch(error => {
                const message = 'Erreur dans la récupération des utilisateurs';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    const onSubmit = (data) => {
        const found = users.find(current => current.id === data.userId);
        setUser(found);
        onClose(null, true);
    };

    return (
        <Dialog open={open} onClose={(event, reason) => onClose(reason, false)} sx={{
          "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                  width: "100%",
                  maxWidth: "300px"
              }
          }
        }}>
            <DialogTitle>Identification</DialogTitle>
            <DialogContent>
                {users ? (
                    <form id="identificationForm" onSubmit={handleSubmit(onSubmit)}>
                        <FormControl sx={{mt: 1}} fullWidth>
                            <Controller
                                name="userId"
                                id="userId"
                                control={control}
                                render={({field}) => (
                                    <RadioGroup {...field}>
                                        {users.map(current => (
                                            <FormControlLabel key={current.id} value={current.id} control={<Radio />} label={current.firstName} />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>
                        <Typography variant="inherit" color="textSecondary">{errors.userId?.message}</Typography>
                    </form>
                ) : (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="20vh">
                        <CircularProgress />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="identificationForm">OK</Button>
                <Button onClick={() => onClose(null, false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
